// JsFromRoutes CacheKey da259adddcbe50abc0e97981f67a56f7
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/testing_tools/calendar/events/:event_id/test_reminder'),
}
